import { render, staticRenderFns } from "./PeriodComp.vue?vue&type=template&id=71bd3e28&scoped=true&"
import script from "./PeriodComp.vue?vue&type=script&lang=js&"
export * from "./PeriodComp.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./PeriodComp.vue?vue&type=style&index=1&id=71bd3e28&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bd3e28",
  null
  
)

export default component.exports